import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { headerInterceptor } from './header.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(), 
      withInterceptors([headerInterceptor])
    ),
    // provideClientHydration()
    // provideAnimations(),   
    // provideToastr({         
    //   positionClass: 'toast-top-right',
    //   timeOut: 5000,
    //   preventDuplicates: true,
    //   newestOnTop: true,
    //   maxOpened: 3,
    //   autoDismiss: true
    // }),
  ]
};
